/**
 * Adres defteri sayfası — kayıtlı host'lar + pin + WoL + düzenle/sil.
 */
import { appState } from '../state';
import { loadSavedHosts, upsertHost, deleteHost, validateMac, } from '../services/address-book';
import { SignalingClient } from '../services/signaling-client';
import { applyStyle, escapeHtml } from '../ui/css';
import { createButton } from '../ui/components/button';
import { createPageHeader } from '../ui/components/pageHeader';
import { icons } from '../ui/icons';
export function renderAddressBook() {
    const root = document.createElement('div');
    const addBtn = createButton({
        label: 'Yeni kayıt',
        variant: 'primary',
        iconHtml: icons.users(),
        onClick: () => openEditor(),
    });
    root.append(createPageHeader({
        title: 'Adres',
        highlight: 'Defteri',
        subtitle: 'Sıkça bağlandığın PC\'leri kaydet — pin ile üstte tut, MAC adresi ile uzaktan uyandır.',
        rightSlot: addBtn,
    }));
    const list = document.createElement('div');
    list.id = 'list';
    applyStyle(list, {
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-3)',
    });
    root.append(list);
    refresh();
    function refresh() {
        const hosts = loadSavedHosts(appState.userEmail)
            .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
        if (hosts.length === 0) {
            list.innerHTML = '';
            const empty = document.createElement('div');
            applyStyle(empty, {
                padding: 'var(--sp-7)',
                textAlign: 'center',
                background: 'var(--bg-elev-2)',
                border: '1px dashed var(--border-strong)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--text-tertiary)',
            });
            empty.innerHTML = `
        <div style="font-size:32px;margin-bottom:var(--sp-3)">📒</div>
        <div style="font-size:var(--fs-body);color:var(--text-secondary);max-width:380px;margin:0 auto">
          Henüz kayıt yok. Üst sağdan <strong style="color:var(--accent)">Yeni kayıt</strong> ile başla.
        </div>
      `;
            list.append(empty);
            return;
        }
        list.innerHTML = '';
        for (const h of hosts)
            list.append(buildHostRow(h));
    }
    function buildHostRow(h) {
        const row = document.createElement('article');
        row.dataset.id = h.id;
        applyStyle(row, {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--sp-3)',
            padding: 'var(--sp-4)',
            background: 'var(--bg-elev-2)',
            border: '1px solid ' + (h.pinned ? 'var(--accent)' : 'var(--border-subtle)'),
            borderRadius: 'var(--radius-md)',
            flexWrap: 'wrap',
            transition: 'border-color var(--motion-fast)',
        });
        row.addEventListener('mouseenter', () => {
            if (!h.pinned)
                row.style.borderColor = 'var(--border-strong)';
        });
        row.addEventListener('mouseleave', () => {
            row.style.borderColor = h.pinned ? 'var(--accent)' : 'var(--border-subtle)';
        });
        const ic = document.createElement('div');
        ic.innerHTML = h.pinned ? icons.pin() : icons.monitor();
        applyStyle(ic, {
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: h.pinned ? 'var(--accent-soft)' : 'var(--bg-elev-3)',
            color: h.pinned ? 'var(--accent)' : 'var(--text-secondary)',
            borderRadius: 'var(--radius-sm)',
            flexShrink: '0',
        });
        row.append(ic);
        const info = document.createElement('div');
        applyStyle(info, { flex: '1', minWidth: '200px', display: 'flex', flexDirection: 'column', gap: '4px' });
        info.innerHTML = `
      <div style="display:flex;align-items:center;gap:var(--sp-2);flex-wrap:wrap">
        <strong style="color:var(--text-primary);font-size:var(--fs-body)">${escapeHtml(h.nickname)}</strong>
        <code style="font-family:var(--font-mono);font-size:var(--fs-caption);color:var(--text-tertiary);letter-spacing:0.06em">${escapeHtml(formatHumanId(h.humanId))}</code>
      </div>
      ${h.notes ? `<div style="font-size:var(--fs-caption);color:var(--text-secondary);font-style:italic">${escapeHtml(h.notes)}</div>` : ''}
      ${h.macAddress ? `<div style="font-size:var(--fs-tiny);color:var(--text-tertiary)">MAC: <code style="font-family:var(--font-mono)">${escapeHtml(h.macAddress)}</code></div>` : ''}
      ${h.lastUsedAt ? `<div style="font-size:var(--fs-tiny);color:var(--text-tertiary)">Son: ${escapeHtml(new Date(h.lastUsedAt).toLocaleString())}</div>` : ''}
    `;
        row.append(info);
        const actions = document.createElement('div');
        applyStyle(actions, { display: 'flex', gap: '6px', flexWrap: 'wrap' });
        const connect = createButton({
            label: 'Bağlan',
            variant: 'primary',
            size: 'sm',
            iconHtml: icons.arrowRight(),
            iconRight: true,
            onClick: () => {
                localStorage.setItem('photon.pending_connect', h.humanId);
                appState.navigate('connect');
            },
        });
        actions.append(connect);
        if (h.macAddress) {
            const wol = createButton({
                label: 'Uyandır',
                variant: 'secondary',
                size: 'sm',
                iconHtml: icons.refresh(),
                onClick: async () => {
                    try {
                        const sig = new SignalingClient();
                        await sig.connect('wss://signal.photondownload.com/ws', appState.accessToken ?? '');
                        sig.sendWakeOnLan(h.id, h.macAddress);
                        setTimeout(() => sig.close(), 500);
                        alert(`✓ Uyandırma sinyali gönderildi (${h.nickname})`);
                    }
                    catch (e) {
                        alert('WoL hatası: ' + e);
                    }
                },
            });
            actions.append(wol);
        }
        const pinBtn = createButton({
            label: h.pinned ? 'Sabit' : 'Sabitle',
            variant: h.pinned ? 'subtle' : 'ghost',
            size: 'sm',
            iconHtml: icons.pin(),
            onClick: () => {
                h.pinned = !h.pinned;
                upsertHost(appState.userEmail, h);
                refresh();
            },
        });
        actions.append(pinBtn);
        const editBtn = createButton({
            label: '',
            variant: 'subtle',
            size: 'sm',
            iconHtml: icons.settings(),
            attrs: { title: 'Düzenle' },
            onClick: () => openEditor(h),
        });
        actions.append(editBtn);
        const delBtn = createButton({
            label: '',
            variant: 'subtle',
            size: 'sm',
            iconHtml: icons.trash(),
            attrs: { title: 'Sil' },
            onClick: () => {
                if (!confirm(`"${h.nickname}" silinsin?`))
                    return;
                deleteHost(appState.userEmail, h.id);
                refresh();
            },
        });
        delBtn.style.color = 'var(--status-error)';
        actions.append(delBtn);
        row.append(actions);
        return row;
    }
    function openEditor(existing) {
        const dialog = document.createElement('div');
        applyStyle(dialog, {
            position: 'fixed',
            inset: '0',
            background: 'rgba(10,14,26,0.78)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '1000',
            backdropFilter: 'blur(4px)',
        });
        const card = document.createElement('div');
        applyStyle(card, {
            background: 'var(--bg-elev-2)',
            padding: 'var(--sp-5)',
            borderRadius: 'var(--radius-lg)',
            minWidth: '440px',
            maxWidth: '90vw',
            border: '1px solid var(--border-subtle)',
            boxShadow: 'var(--shadow-elev)',
        });
        card.innerHTML = `
      <h2 style="margin:0 0 var(--sp-3);font-family:var(--font-display);font-style:italic;font-weight:500;font-size:24px">
        ${existing ? 'Kaydı düzenle' : 'Yeni kayıt'}
      </h2>
      <div style="display:flex;flex-direction:column;gap:var(--sp-3)">
        ${labelField('ed-nick', 'Takma Ad', existing?.nickname ?? '', 'Ofis PC')}
        ${labelField('ed-hid', 'Human ID', existing?.humanId ?? '', '123 456 789', true)}
        ${labelTextarea('ed-notes', 'Not (opsiyonel)', existing?.notes ?? '')}
        ${labelField('ed-mac', 'MAC adresi (WoL için, opsiyonel)', existing?.macAddress ?? '', 'AA:BB:CC:DD:EE:FF', true)}
      </div>
    `;
        const btnRow = document.createElement('div');
        applyStyle(btnRow, { display: 'flex', gap: 'var(--sp-2)', marginTop: 'var(--sp-4)' });
        const cancelBtn = createButton({
            label: 'İptal',
            variant: 'ghost',
            onClick: () => dialog.remove(),
        });
        const saveBtn = createButton({
            label: 'Kaydet',
            variant: 'primary',
            iconHtml: icons.copy(),
            onClick: () => {
                const nick = card.querySelector('#ed-nick').value.trim();
                const hid = card.querySelector('#ed-hid').value.trim();
                const notes = card.querySelector('#ed-notes').value.trim();
                const mac = card.querySelector('#ed-mac').value.trim();
                if (!nick || !hid) {
                    alert('Takma ad ve Human ID zorunlu');
                    return;
                }
                if (mac && !validateMac(mac)) {
                    alert('MAC adresi geçersiz');
                    return;
                }
                const item = {
                    id: existing?.id ?? crypto.randomUUID(),
                    nickname: nick, humanId: hid, notes,
                    pinned: existing?.pinned ?? false,
                    macAddress: mac || undefined,
                    createdAt: existing?.createdAt ?? new Date().toISOString(),
                    lastUsedAt: existing?.lastUsedAt,
                };
                upsertHost(appState.userEmail, item);
                dialog.remove();
                refresh();
            },
        });
        btnRow.append(cancelBtn, saveBtn);
        card.append(btnRow);
        dialog.append(card);
        dialog.addEventListener('click', (e) => {
            if (e.target === dialog)
                dialog.remove();
        });
        document.body.appendChild(dialog);
    }
    return root;
}
function labelField(id, label, value, placeholder, mono = false) {
    return `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      ${escapeHtml(label.toUpperCase())}
      <input id="${id}" value="${escapeHtml(value)}" placeholder="${escapeHtml(placeholder)}"
             autocapitalize="none" autocorrect="off" spellcheck="false"
             style="padding:10px 14px;font-size:var(--fs-body);${mono ? 'font-family:var(--font-mono);' : ''}background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
  `;
}
function labelTextarea(id, label, value) {
    return `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      ${escapeHtml(label.toUpperCase())}
      <textarea id="${id}" rows="2"
                style="padding:10px 14px;font-size:var(--fs-body);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary);font-family:inherit;resize:vertical">${escapeHtml(value)}</textarea>
    </label>
  `;
}
function formatHumanId(id) {
    const clean = id.replace(/\s+/g, '');
    if (clean.length <= 3)
        return clean;
    return clean.match(/.{1,3}/g)?.join(' ') ?? clean;
}
